import { Component } from '@theme/component';

/** Keep the server-selected collection visible without scrolling the page. */
class DarCollectionNavigation extends Component {
  /** @type {ResizeObserver | undefined} */
  #observer;
  #frame;
  #generation = 0;

  connectedCallback() {
    super.connectedCallback();
    const generation = ++this.#generation;
    this.#observer?.disconnect();
    this.#observer = new ResizeObserver(this.#schedule);
    this.#observer.observe(this);
    this.#schedule();
    document.fonts.ready.then(() => {
      if (this.isConnected && generation === this.#generation) this.#schedule();
    });
  }

  updatedCallback() {
    super.updatedCallback();
    this.#schedule();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#observer?.disconnect();
    cancelAnimationFrame(this.#frame);
    this.#generation++;
  }

  #schedule = () => {
    cancelAnimationFrame(this.#frame);
    this.#frame = requestAnimationFrame(() => {
      if (!this.isConnected) return;
      const bar = this.querySelector('nav');
      const active = bar?.querySelector('[aria-current="page"]');
      if (!(bar instanceof HTMLElement) || !(active instanceof HTMLElement)) return;
      if (!bar.clientWidth) return;
      const bounds = bar.getBoundingClientRect();
      const target = active.getBoundingClientRect();
      const delta = target.left + target.width / 2 - (bounds.left + bar.clientLeft + bar.clientWidth / 2);
      const max = Math.max(0, bar.scrollWidth - bar.clientWidth);
      const rtl = getComputedStyle(bar).direction === 'rtl';
      const minScroll = rtl ? -max : 0;
      const maxScroll = rtl ? 0 : max;
      // Clamp WebKit's possible rubber-band offsets; never scroll an ancestor.
      bar.scrollLeft = Math.max(minScroll, Math.min(maxScroll, bar.scrollLeft + delta));
    });
  };
}

if (!customElements.get('dar-collection-navigation')) {
  customElements.define('dar-collection-navigation', DarCollectionNavigation);
}
